import { fetchOrders } from './orderApi';
import { fetchCustomers } from './customerApi';

// Group orders into last 7 days (current) vs previous 7 days (previous)
export async function fetchSalesOverview() {
  try {
    // Load a reasonable number of recent orders
    const params = new URLSearchParams({
      page: '1',
      limit: '200',
      sortBy: 'createdAt',
      sortOrder: 'desc',
    });
    const { orders } = await fetchOrders(params);

    const now = new Date();
    const startOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const days = Array.from(
      { length: 7 },
      (_, i) => new Date(startOfToday.getTime() - (6 - i) * 86400000)
    );
    const prevDays = Array.from(
      { length: 7 },
      (_, i) => new Date(startOfToday.getTime() - (13 - i) * 86400000)
    );

    const dayKey = (d) => d.toISOString().slice(0, 10);
    const makeMap = (arr) =>
      arr.reduce((acc, d) => {
        acc[dayKey(d)] = 0;
        return acc;
      }, {});
    const currentMap = makeMap(days);
    const previousMap = makeMap(prevDays);

    for (const o of orders || []) {
      const created = o.createdAt ? new Date(o.createdAt) : null;
      if (!created) continue;
      const key = dayKey(created);
      if (key in currentMap) currentMap[key] += 1;
      else if (key in previousMap) previousMap[key] += 1;
    }

    const weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const data = days.map((d) => ({
      label: weekday[d.getDay()],
      current: currentMap[dayKey(d)] || 0,
      previous: previousMap[dayKey(new Date(d.getTime() - 7 * 86400000))] || 0,
    }));
    return data;
  } catch (e) {
    // Fallback static
    return [
      { label: 'Mon', current: 40, previous: 28 },
      { label: 'Tue', current: 24, previous: 27 },
      { label: 'Wed', current: 30, previous: 26 },
      { label: 'Thu', current: 42, previous: 31 },
      { label: 'Fri', current: 26, previous: 19 },
      { label: 'Sat', current: 33, previous: 22 },
      { label: 'Sun', current: 30, previous: 24 },
    ];
  }
}

// Compute simple customer counts by country (top 4) from admin customers
export async function fetchCustomerGrowth(regionKey = 'Asian Country') {
  try {
    const params = new URLSearchParams({ page: '1', limit: '200' });
    const { customers } = await fetchCustomers(params);
    const counts = new Map();
    for (const c of customers || []) {
      const country = c.address?.country || c.address?.countryCode || 'Unknown';
      counts.set(country, (counts.get(country) || 0) + 1);
    }
    const sorted = Array.from(counts.entries())
      .sort((a, b) => b[1] - a[1])
      .slice(0, 4);
    const palette = ['#0DA574', '#FF7A00', '#2F80ED', '#FF1E1E'];
    const result = sorted.map(([name, value], i) => ({
      name,
      iso3: '',
      color: palette[i % palette.length],
      value,
    }));
    return { [regionKey]: result };
  } catch (e) {
    // Fallback static
    return {
      'Asian Country': [
        { name: 'Saudi Arabia', iso3: 'SAU', color: '#0DA574', value: 42 },
        { name: 'India', iso3: 'IND', color: '#FF7A00', value: 28 },
        { name: 'South Korea', iso3: 'KOR', color: '#2F80ED', value: 17 },
        { name: 'Indonesia', iso3: 'IDN', color: '#FF1E1E', value: 13 },
      ],
    };
  }
}
